import { Injectable, inject } from '@angular/core';
import { ModalRef, ModalService } from '@schenck/rotec-components';
import { BehaviorSubject } from 'rxjs';
import { ChartOverlayData } from './chart-overlay.models';

export interface LegendData {
  asset: string;
  compareAsset: string;
  showCircle?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ChartOverlayService {
  private readonly modalService = inject(ModalService);

  public async openChartOverlay(
    chartOverlayData: BehaviorSubject<ChartOverlayData | undefined>
  ): Promise<ModalRef<BehaviorSubject<ChartOverlayData>>> {
    const { ChartOverlayComponent } = await import('./chart-overlay/chart-overlay.component');
    return this.modalService.open(ChartOverlayComponent, chartOverlayData);
  }
}
